import { render, staticRenderFns } from "./Info.vue?vue&type=template&id=484eb8da&scoped=true&"
import script from "./Info.vue?vue&type=script&lang=js&"
export * from "./Info.vue?vue&type=script&lang=js&"
import style0 from "./Info.vue?vue&type=style&index=0&id=484eb8da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484eb8da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('484eb8da')) {
      api.createRecord('484eb8da', component.options)
    } else {
      api.reload('484eb8da', component.options)
    }
    module.hot.accept("./Info.vue?vue&type=template&id=484eb8da&scoped=true&", function () {
      api.rerender('484eb8da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/budget-control/status/components/Info.vue"
export default component.exports